export default __webpack_public_path__ + "img/quantity-more.a8dca30.svg";